import { renderState, mergeStates } from "../../../../core/js/state-machine";
import { componentClasses, views } from "../../../../core/components/table/body/cell";

export const tableCellTemplate = ({ value }) => {
    return `<span class="${componentClasses.cell}">${value}</span>`;
};

export default (config) => {
    const style = renderState(mergeStates(views.rest, views.align[config.align]));
    return `<div class="${style.classList.join(" ")}" ${style.attrs}>
    ${tableCellTemplate(config)}
</div>`;
};
